import { useEffect, useState } from "react";

import { P1 } from "@/Components";
import BasicMultipleLineGraph from "@/Components/EChartsGraph/BasicMultipleLineGraph";
import { Typography } from "@/Components/v2/atoms/Typography/Typography";
import { useInfo } from "@/context/InfoProvider/InfoProvider";

import { handleSourceData, INIT_FEED_DATA } from "./BrandMetricMethod";

const BrandMetricGraph = (props) => {
  const { sourceData } = props;
  const { theme: colorTheme } = useInfo();

  const [feedData, setFeedData] = useState(INIT_FEED_DATA);

  useEffect(() => {
    if (sourceData?.date) {
      handleSourceData({
        sourceData: sourceData,
        setFeedData: setFeedData,
        colorTheme: colorTheme,
      });
    }
  }, [sourceData, colorTheme]);

  return (
    <>
      <Typography variant="h2" fontSize={20} fontWeight={600}>
        Brand metrics
      </Typography>
      <P1 fSize={10} fweight={600} mrtop={40} mrbottom={8} mrleft={6}>
        Brand metrics (out of 100)
      </P1>
      <BasicMultipleLineGraph
        hoverData={{
          componentName: "Basic",
          data: {
            signBefore: "",
            signAfter: "",
          },
        }}
        legendLabel={feedData.legendLabel}
        xAxisData={feedData.date}
        seriesData={feedData.seriesData}
      />
    </>
  );
};

export default BrandMetricGraph;
